<template>
  <div class="product-card-view">
    <div class="results">
      <push-best-seller class="result-item" v-if="selectedCategory.code==='machines' && !marketFilter"/>
      <push-oxygen class="result-item" v-if="selectedCategory.code==='machines' && !marketFilter"/>
        <card-machine
            class="result-item"
            v-for="(result, index) in results"
            :key="result.identifier"
            :style="'order:'+index"
            :datas="result"
            :hide="selectedCategory.code==='machines'"
            :class="{'is-bestseller': result.isBestSeller && $store.state.settings.region==='R1','is-new': result.isNew }"
        />
    </div>
  </div>
</template>

<script>
import CardMachine from "@/components/Card/CardMachine";
import {mapState} from "vuex";
import PushBestSeller from "@/components/Push/PushBestSeller.vue"
import PushOxygen from "@/components/Push/PushOxygen";

export default {
  name: "CardView",
  components : {
    CardMachine,
    PushBestSeller,
    PushOxygen
  },
  computed : {
    ...mapState({
      filtersList: state => state.searchMachines.filtersList,
      results: state=>state.searchMachines.results,
      selectedCategory: state => state.searchMachines.category,
      marketFilter: state => state.searchMachines.marketFilter
    }),
  }
}
</script>

<style lang="scss" scoped>
.results {
  align-items: stretch;
}
</style>